import React from 'react';

import { IComponentInput } from '../../component.d';
import { RenderRequired } from './Form';

const AllForFormInput = function(props: IComponentInput) {
  const {
    field,
    align,
    width,
    onChange,
    required,
    placeholder,
    label,
    type
  } = props;
  return (
    <div className="all-for-input">
      <div className="weui-cells__group weui-cells__group_form">
        <div
          className="weui-cells weui-cells_form"
          style={{ width: `${width}%` }}
        >
          <div className="weui-cell weui-cell_active">
            {label ? (
              <div className="weui-cell__hd">
                <label className="weui-label">
                  {field} {RenderRequired(required)}
                </label>
              </div>
            ) : null}
            <div className="weui-cell__bd">
              <input
                className="weui-input"
                placeholder={placeholder}
                onChange={e => {
                  onChange && onChange(type, field, e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllForFormInput;
